import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../../components/ui/alert-dialog";
import { useToast } from "../../../hooks/use-toast";
import { useDeleteOperation } from "../hooks/use-operations-queries";
import { Operation } from "../types";

interface DeleteOperationDialogProps {
  operation: Operation | null;
  isOpen: boolean;
  onClose: () => void;
}

export function DeleteOperationDialog({
  operation,
  isOpen,
  onClose,
}: DeleteOperationDialogProps) {
  const { toast } = useToast();
  const deleteOperation = useDeleteOperation();

  const handleDelete = async () => {
    if (!operation) {
      return;
    }

    if (operation.ops === "gestor") {
      toast({
        title: "Erro",
        description:
          "Não é possível excluir a operação 'gestor' (crítica para o sistema)",
        variant: "destructive",
      });
      return;
    }

    try {
      await deleteOperation.mutateAsync(operation.ops);
      toast({
        title: "Sucesso",
        description: "Operação excluída com sucesso!",
      });
      onClose();
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Erro ao excluir a operação";
      toast({
        title: "Erro",
        description: errorMessage,
        variant: "destructive",
      });
      console.error("Error deleting operation:", error);
    }
  };

  if (!operation) {
    return null;
  }

  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Você tem certeza disso?</AlertDialogTitle>
          <AlertDialogDescription>
            Isso irá excluir permanentemente a operação{" "}
            <strong>{operation.displayName}</strong> ({operation.ops}),
            incluindo todas as suas configurações de telas e uploads. Essa ação
            não pode ser desfeita.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={deleteOperation.isPending}>
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            disabled={deleteOperation.isPending || operation.ops === "gestor"}
            className="bg-red-600 hover:bg-red-700"
          >
            {deleteOperation.isPending ? "Excluindo..." : "Excluir Operação"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
